
import { mapGetters } from 'vuex'

import card from '~/mixins/card'
export default {
    mixins: [card],
    props: {
        magicUrl: {
            type: String,
            default: '/'
        },
    },
    data () {
        return {
            enrollModal: false,
            enrollPlan: null,
        }
    },
    computed: {
        ...mapGetters([
            'uid',
            'surveyRoutesMap',
            'isPlanInOpportunities',
            'summarySwitchedOnCardsCombos',
            'fullservePlus',
        ]),
    },
    methods: {
        isPlanCommissionable (plan) {
            return plan.commissionable_status !== false
        },
        shouldAgentEnrollPlan (plan) {
            return this.isPlanIncluded(plan) && (this.isPlanCommissionable(plan) || this.fullservePlus) && this.isPlanAgentEnrollable(plan)
        }
    }
}
